import { cloneDeep } from 'lodash'
import create, { SetState, StateCreator, StoreApi } from 'zustand'

interface VitalsStore {
    data : any,
    setdata : (x:any) => void
    dataCardId?: number,
    setdataCardId: (x: number) => void,
    patientId?: number,
    setPatientId: (x: number) => void,
    vitalLoader: any;
    setVitalLoader: (x: any) => void;
    clearStore: () => void
}

// const initialInput: any[] = [
//     {
//         name: 'BMI',
//         value: '20 kg/m^2',
//         inRange: 'Y',
//         refreshDate: '2022-12-30',
//         icon: 'bmi',
//         canEdit: false,
//         haveGraph: true
//     },
//     {
//         name: 'Height',
//         value: '20 kg/m^2',
//         inRange: 'N',
//         refreshDate: '2022-12-30',
//         icon: 'height',
//         canEdit: false,
//         haveGraph: false
//     },
//     {
//         name: 'Weight',
//         value: '20 kg/m^2',
//         inRange: 'NA',
//         refreshDate: '2022-12-30',
//         icon: 'weight',
//         canEdit: true,
//         haveGraph: true
//     },
//     {
//         name: 'Systolic',
//         value: '20 kg/m^2',
//         inRange: 'Y',
//         refreshDate: '2022-12-30',
//         icon: 'systolic',
//         canEdit: false,
//         haveGraph: true
//     },
//     {
//         name: 'Diastollic',
//         value: '20 kg/m^2',
//         inRange: 'N',
//         refreshDate: '2022-12-30',
//         icon: 'diastolic',
//         canEdit: false,
//         haveGraph: true
//     },
//     {
//         name: 'Pulse',
//         value: '20 kg/m^2',
//         inRange: 'NA',
//         refreshDate: '2022-12-30',
//         icon: 'pulse',
//         canEdit: false,
//         haveGraph: true
//     },
//     {
//         name: 'Temperature',
//         value: '20 kg/m^2',
//         inRange: 'NA',
//         refreshDate: '2022-12-30',
//         icon: 'temperature',
//         canEdit: false,
//         haveGraph: false
//     },
//     {
//         name: 'Oxygen Saturation',
//         value: '20 kg/m^2',
//         inRange: 'Y',
//         refreshDate: '2022-12-30',
//         icon: 'oxygenSaturation',
//         canEdit: false,
//         haveGraph: true
//     },
//     {
//         name: 'Respiration',
//         value: '20 kg/m^2',
//         inRange: 'N',
//         refreshDate: '2022-12-30',
//         icon: 'respiration',
//         canEdit: false,
//         haveGraph: true
//     }
// ]

let  store: StateCreator<VitalsStore, [], [], VitalsStore> | StoreApi<VitalsStore> = (set: SetState<VitalsStore>) => ({
    data: null,
    setdata: (x) => {
        set(state => ({ data : cloneDeep(x) }))
    },
    dataCardId: undefined,
    setdataCardId: (dataCardId) => {
        set(state => ({ dataCardId }))
    },
    patientId: undefined,
    setPatientId: (patientId) => {
        set(state => ({ patientId }))
    },
    vitalLoader: false,
    setVitalLoader: (x) => {
        set(() => ({ vitalLoader: x }));
    },
    clearStore: () => {
        set(() => ({data:  null, dataCardId: undefined, vitalLoader: false,}))
    }
})


export const useVitalsStore  = create(store)
